<template>
<div class="row" v-loading="loading">
  <div class="col-md-12">
    <card :title="title" v-if="modelSchema">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <fg-input  :error="errorMessages.email"
                     :max-length="modelSchema.email.maxLength"
                     :required="modelSchema.email.required"
                     v-model="model.email"
                     :placeholder="'E-mail' | translate"
                     :label="'E-mail' | translate"></fg-input>
        </div>
        <div class="col-md-4 col-sm-12">
          <fg-input  :error="errorMessages.lastName"
                     :max-length="modelSchema.lastName.maxLength"
                     :required="modelSchema.lastName.required"
                     v-model="model.lastName"
                     :placeholder="'Last name' | translate"
                     :label="'Last name' | translate"></fg-input>
        </div>
        <div class="col-md-4 col-sm-12">
          <fg-input  :error="errorMessages.firstName"
                     :max-length="modelSchema.firstName.maxLength"
                     :required="modelSchema.firstName.required"
                     v-model="model.firstName"
                     :placeholder="'First name' | translate"
                     :label="'First name' | translate"></fg-input>
        </div>
        <div class="col-md-4 col-sm-12">
          <fg-input  :error="errorMessages.secondName"
                     :max-length="modelSchema.secondName.maxLength"
                     :required="modelSchema.secondName.required"
                     v-model="model.secondName"
                     :placeholder="'Second name' | translate"
                     :label="'Second name' | translate"></fg-input>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label><translate>Invitation language</translate></label>
            <el-select class="select-info"
                       :placeholder="'Select invitation language' | translate"
                       v-model="model.language">
              <el-option v-for="option in languages"
                         class="select-info"
                         :value="option.value"
                         :label="option.label"
                         :key="option.label">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <p-button type="info" round @click="saveAndClose">
        <translate key="add" v-if="!isNew">Save</translate>
        <translate key="save" v-else>Add</translate>
      </p-button>
<!--      <p-button type="info" round @click="saveAndClose">-->
<!--        <translate key="add" v-if="!isNew">Save and close</translate>-->
<!--        <translate key="save" v-else>Add and close</translate>-->
<!--      </p-button>-->

    </card> <!-- end card -->
  </div> <!--  end col-md-6  -->
</div>
</template>

<script>
  import _ from 'lodash'
  import { Card } from 'src/components/UIComponents'
  import moment from 'moment'
  import {Select, Option, OptionGroup, DatePicker, TimePicker} from 'element-ui'
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

  export default {
    components: {
      Card,
      [DatePicker.name]: DatePicker,
      [TimePicker.name]: TimePicker,
      [Select.name]: Select,
      [OptionGroup.name]: OptionGroup,
      [Option.name]: Option
    },
    name: 'InvitationForm',
    beforeRouteEnter: (to, from, next) => {
      next(vm => {
        if (to.params.invitationId) {
          vm.loadRecord(to.params.invitationId)
        }
      })
    },
    beforeRouteUpdate: (to, from, next) => {
      next(vm => {
        if (to.params.invitationId) {
          vm.loadRecord(to.params.invitationId)
        }
      })
    },
    breadcrumb () {
      return {
        label: this.title,
        parent: {
          name: 'stands-index'
        }
      }
    },
    computed: {
      baseApi () {
        return `/invitation/`
      },
      ...mapState({
        currentEvent: state => state.events.current,
        currentEventInfo: state => state.events.currentEventInfo,
        // available: state => state.events.available
      }),
      title () {
        if (this.isNew) {
          return this.$gettext('Invite')
        } else {
          return this.$gettext('Edit invitation')
        }
      },
      isNew () {
        return this.model.id === null
      }
    },
    created () {
      this.getSchema()

    },
    props: {
      value: {
        type: [Object],
        description: "ID of record",
        default () {
          return {
            modelId: this.$route.params.invitationId || null,
            show: true
          }
        }
      },
      source: !Object,
      isModal: {
        type: Boolean,
        description: "Флаг модальное ли окно"
      },
      modelId: {
        type: Number,
        required: false
      }
    },
    mounted () {
      if (this.value.modelId || this.model.id) {
        this.loadRecord(this.value.modelId)
      } else if (this.value.model) {
        this.model = this.value.model
      }
    },
    beforeUpdate () {
      if (this.value.model) {
        this.model = this.value.model
      }
    },
    data () {
      return {
        languages: [
          {'value': 'ru', label: this.$gettext("Russian")},
          {'value': 'en', label: this.$gettext("English")},
        ],
        dropzoneOptions: {
          url: '/api/filer/file/upload/',
          thumbnailMethod: 'contain',
          acceptedFiles: 'image/*,application/pdf',
          thumbnailWidth: 150,
          thumbnailHeight: 150,
          maxFilesize: 50,
          maxFiles: 1,
          headers: { }
        },
        loading: false,
        errorMessages: {},
        schema: null,
        modelSchema: null,
        model: this.clearModel()
      }
    },
    watch: {
      'value.modelId' (newValue) {
        if (!this.value.model) {
          if (newValue === null) {
            this.model = this.clearModel()
          } else {
            this.loadRecord(newValue)
          }
        }
      }
    },
    methods: {
      dropzoneFileAdded (file) {
        // Добавление авторизации к загрузке
        this.dropzoneOptions.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`
      },
      dropzoneFileSuccess (file, response) {
        this.model.file = response.id
        this.model.fileUrl = response.file
        if (!this.model.name) {
          this.model.name = response.originalFilename
        }
      },
      clearModel () {
        return {
          id: null,
          lastName: null,
          firstName: null,
          secondName: null,
          email: null,
          language: 'ru'
        }
      },
      updateModel (model) {
        this.model = model
      },
      prepareModelToSave() {
        let model = _.cloneDeep(this.model)
        model.source = this.source
        return model
      },
      async loadRecord (id) {
        this.loading = true
        const result = await this.$http.get(`${this.baseApi}${id}/`)
        this.updateModel(result.data)
        this.loading = false
        return result.data
      },
      async getSchema () {
        let url = this.baseApi
        const result = await this.$http.options(url)
        this.schema = result.data
        this.modelSchema = this.schema.actions.POST
      },
      async save () {
        this.loading = true
        const modelToSave = this.prepareModelToSave()
        const request = this.isNew ? this.$http.post(this.baseApi, modelToSave) : this.$http.put(`${this.baseApi}${this.model.id}/`, modelToSave)
        try {
          const result = await request
          this.$emit('on-invitation', result.data)
          this.updateModel(result.data)
          this.loading = false
          this.errorMessages = {}
          this.$emit('reload-content')
          return true
        } catch (error) {
          this.loading = false
          this.errorMessages = _.mapValues(error.response.data, x => x instanceof Array ? x.join(', ') : x)
          return false
        }
      },
      async saveAndClose () {
        if (await this.save()) {
          if (this.isModal) {
            this.value.show = false
            this.value.modelId = null
            this.model = this.clearModel()
            this.$emit('modal-close', false)
          } else {
            this.$router.go(-1)
          }
        }
      }
    }
  }
</script>

<style scoped>
  .col-md-4 {
    padding-left: 5px;
    padding-right: 5px;
  }
  .card .card-header .card-title {
    font-size: 2em;
  }
</style>
